package com.milta.core.localization.translations.es

import com.milta.core.localization.RouteCreationStrings

internal val RouteCreation = RouteCreationStrings(
    newRouteTitle = "Nueva ruta",
    stepDeliveries = "Entregas",
    stepDrivers = "Conductores",
    stepDistribution = "Reparto",
    deliveriesSummary = "%1 entregas · %2 bultos",
    deliveriesSummaryOne = "1 entrega · %1 bultos",
    toFixCount = "%1 por corregir",
    allAddressesCorrect = "Todas las direcciones son correctas",
    filterAll = "Todas %1",
    filterToFix = "Por corregir %1",
    fixAddressesToContinue = "Corrija %1 direcciones para continuar",
    fixOneAddressToContinue = "Corrija 1 dirección para continuar",
    continueWithDeliveries = "Continuar · %1 entregas",
    continueWithOneDelivery = "Continuar · 1 entrega",
    chooseAtLeastOneDriver = "Elija al menos un conductor",
    reasonMissingHouseNumber = "Falta el número de la calle",
    reasonNotFound = "Dirección no encontrada",
    reasonUnverified = "No se pudo verificar, inténtelo de nuevo",
    missingHouseNumberExample = "Falta el número de la calle. Ejemplo: %1",
    notFoundHelp = "Dirección no encontrada. Compruebe la calle, el número y el código postal.",
    unverifiedHelp = "No se ha podido verificar la dirección por ahora. Inténtelo de nuevo en unos instantes.",
    addToExistingHint = "Se añaden a las %1 entregas que ya están en la lista.",
    importFileAction = "Importar un archivo",
    importFileHint = "Excel (.xlsx, .xls), CSV o PDF",
    manualEntryAction = "Entrada manual",
    manualEntryHint = "Nombre, dirección, teléfono, hora límite",
    addDeliveryTitle = "Añadir una entrega",
    deleteDelivery = "Eliminar la entrega",
    addedFileAnalysing = "Analizando %1…",
    addedFileFailed = "La importación de %1 no se completó. No se ha añadido ninguna entrega.",
    errorAddressesToFix = "Algunas direcciones no se han validado: corríjalas en la lista «Por corregir».",
    errorAddressesCheckRetry = "La verificación de las direcciones no se ha completado. Inténtelo de nuevo en unos instantes.",
    errorBatchAlreadyDispatched = "Este reparto ya se ha enviado a los conductores.",
    editDeliveryTitle = "Modificar la entrega",
    zoneLabel = "Zona %1",
    workloadBalanced = "Tiempos de trabajo equilibrados entre los conductores",
    workloadGap = "Diferencia de tiempo de trabajo entre los conductores: %1",
    importAddedFromScan = "%1 entregas añadidas desde el escaneo",
    importAddedOneFromScan = "1 entrega añadida desde el escaneo",
    importAddedFromPdf = "%1 entregas añadidas desde el PDF",
    importAddedOneFromPdf = "1 entrega añadida desde el PDF",
    importAddedFromSpreadsheet = "%1 entregas añadidas desde el archivo Excel",
    importAddedOneFromSpreadsheet = "1 entrega añadida desde el archivo Excel",
    importAddedToFixSuffix = ", de las cuales %1 por corregir",
    deliverySearchOpenAction = "Buscar una entrega",
    deliverySearchCount = "%1 de %2",
    deliverySearchCountToFix = "%1 de %2 por corregir",
    deliverySearchEmptyTitle = "Ninguna entrega coincide",
    deliverySearchEmptyToFixHint = "Ninguna entrega por corregir coincide. Prueba en «Todas».",
)
